<template>
     <div class="contact-map">
        <div id="contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d14596.901068434778!2d90.3654296!3d23.8461333!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1625139542728!5m2!1sen!2sbd" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name:'CotactMap'
}
</script>